export enum ResultatAngivesIEnum {
    Heltal = 1,
    Kommatal = 2,
    MultipleChoice = 3
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/enums/ResultatAngivesIEnum.ts